import React from "react";
import ReactDOM from "react-dom";
import "./components/styles/css/index.css";
import App from "./App.jsx";

ReactDOM.render(<App />, document.getElementById("root"));
